// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"So","modify_order":"To","modify_order_header":"Uo","product_details_form_wrapper":"Vo","c_wrapper":"Wo","save_button":"Xo","title":"Yo","modify_order_title_wrapper":"Zo","note":"ap","buttons_wrapper":"bp"};
    if(module.hot) {
      // 1714654883520
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  